/**
 * Giá và lãi theo chính sách (Rẻ / Cân bằng / Đắt).
 * Mọi hệ số đọc từ dữ liệu — không viết cứng.
 */
import type { ChinhSachGiaChon, DuLieuGame } from './types.js';

/** Lãi trung bình mỗi món của một nhóm hàng theo chính sách đang chọn. */
export function laiNhomTheoChinhSach(
  nhom: string,
  chinhSach: ChinhSachGiaChon,
  duLieu: DuLieuGame,
): number {
  const dong = duLieu.bangGiaTheoNhom.find((b) => b.nhom === nhom);
  if (!dong) throw new Error(`Không tìm thấy nhóm hàng "${nhom}" trong bảng giá.`);
  if (chinhSach === 're') return dong.laiRe;
  if (chinhSach === 'canBang') return dong.laiCanBang;
  return dong.laiDat;
}

/** Hệ số cầu f(chính sách): Rẻ 1,2 / Cân bằng 1,0 / Đắt 0,65. */
export function heSoCau(chinhSach: ChinhSachGiaChon, duLieu: DuLieuGame): number {
  return duLieu.chinhSach[chinhSach].heSoCau;
}

/** Danh tiếng ổn định mà chính sách hướng tới. */
export function danhTiengOnDinh(chinhSach: ChinhSachGiaChon, duLieu: DuLieuGame): number {
  return duLieu.chinhSach[chinhSach].danhTiengOnDinh;
}

/** Hệ số giá ×giá gợi ý của chính sách (0,9 / 1,0 / 1,2). */
export function heSoGia(chinhSach: ChinhSachGiaChon, duLieu: DuLieuGame): number {
  return duLieu.chinhSach[chinhSach].heSoGia;
}
